export default __webpack_public_path__ + "static/media/litmus-paper.ee4ca7ea.jpg";